import { PrevailingWageBenefit_Read } from '@treadinc/horizon-api-spec';
import dayjs, { Dayjs } from 'dayjs';

import { Nullable } from '~types/Nullable';

export class PrevailingWageBenefit {
  constructor(
    private _id: string,
    private _name: string,
    private _discarded_at: Nullable<Dayjs> = null,
  ) {}

  public static parse(proto: PrevailingWageBenefit_Read) {
    return new PrevailingWageBenefit(
      proto.id,
      proto.name,
      proto.discarded_at ? dayjs(proto.discarded_at) : null,
    );
  }

  public get id() {
    return this._id;
  }

  public get name() {
    return this._name;
  }

  public get discardedAt() {
    return this._discarded_at;
  }
}
